import React from 'react';
import ModalTypeEnum from 'Modals/ModalConstants';
import connectModal from 'Modals/enhancers/ConnectModal';
import withAnimation from 'Modals/enhancers/AnimateModal';
import BaseModal from 'Modals/BaseModal';
import ExportDocumentModalBodyContent from 'Modals/content/ExportDocumentBodyContent';

const defaultLoadSteps = [
  {
    percent: 65,
    interval: 100,
    content: {
      primaryContent: 'Preparing ',
      isShowingFormat: true,
      isShowingEllipsis: true,
    },
  },
  {
    percent: 75,
    interval: 500,
    content: {
      primaryContent: 'Finalizing Document',
      isShowingFormat: false,
      isShowingEllipsis: true,
    },
  },
  {
    percent: 85,
    interval: 1000,
    content: {
      primaryContent: 'Finalizing Document',
      isShowingFormat: false,
      isShowingEllipsis: true,
    },
  },
  {
    percent: 90,
    interval: 1500,
    content: {
      primaryContent: 'Finalizing Document',
      isShowingFormat: false,
      isShowingEllipsis: true,
    },
  },
  {
    percent: 95,
    interval: 2500,
    content: {
      primaryContent: 'Finalizing Document',
      isShowingFormat: false,
      isShowingEllipsis: true,
    },
  },
  {
    percent: 98,
    interval: 100,
    content: {
      primaryContent: 'Downloading ',
      isShowingFormat: true,
      isShowingEllipsis: false,
    },
  },
];

const FreeWriteExportDocumentModalContainer = connectModal(
  withAnimation(BaseModal, true),
  'export-view',
  {
    modalType: ModalTypeEnum.FREE_WRITE_EXPORT_DOCUMENT,
    headerText: 'Exporting Your Document...',
    loadOptions: {
      loadingBarContent: <ExportDocumentModalBodyContent />,
      loadSteps: defaultLoadSteps,
      isDynamicContent: true,
    },
    ariaLabel: 'Exporting Document Modal',
  },
);

export default FreeWriteExportDocumentModalContainer;



// WEBPACK FOOTER //
// ./src-react/Modals/containers/FreeWriteExportDocumentModal/index.jsx